import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Http } from '@angular/http';
import { RequestBuilder } from '../classes/request-builder';
import { Observable } from 'rxjs';
import * as Enum from '../utils/enums';

@Injectable()
export class RuoloService extends BaseService {

  /**
   * Costruttore
   * @param http Servizio di richieste HTTP 
   */
  constructor(http: Http) {
    super(http);
  }

  /**
   * Get list of Ruoli
   * @param reqBuilder 
   */
  getAllRuoli(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('ruolo/fetch', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * Save new Ruolo
   * @param reqBuilder 
   */
  save(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('ruolo/save', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * delete Ruolo
   * @param reqBuilder 
   */
  deleteRuolo(reqBuilder?: RequestBuilder): Observable<any>{
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('ruolo/delete', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }
}
